import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as TeamInformation } from "assets/img/icons/teaminfo.svg";
import { CSSTransition } from "react-transition-group";
import TeamDelete from "components/TeamDelete";
import Webhook from "components/Webhook";
import ClickAwayListener from "react-click-away-listener";
import "assets/scss/partials/teaminfo.scss";
import TeamEngagement from "components/TeamLevelOfEngagement";
import RecordWelcomeMessage from "components/RecordWelcomeMessage";
import ShowNotifications from "components/ShowNotifications";
import CourseSharing from "components/CourseSharing";
// import ShowChatGpt from "components/ShowChatGpt";

var styles = {
  heading: {
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    boxShadow: "0 0px 6px rgb(0 0 0 / 15%)",
    padding: "15px",
  },
  icon: {
    width: "20px",
    height: "20px",
    fill: "#575f6b",
  },
  rootDropDown: {
    backgroundColor: "white",
    position: "absolute",
    top: "69px",
    left: "-55px",
    transform: "translate3d(56px, -16px, 0px)",
    willChange: "transform",
    zIndex: 1,
    width: "-webkit-fill-available",
  },
  contentDropDown: {
    opacity: 1,
    transform: "none",
    transformOrigin: "right center",
    transition:
      "opacity 229ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 153ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    boxShadow:
      "0px 2px 1px -1px #ccc, 0px 1px 1px 0px #ccc, 0px 1px 3px 0px #ccc",
  },
  list: {
    padding: "8px 5px",
    borderBottom: "1px solid rgb(87 95 107 / 19%)",
  },
};

export default ({ team, setTeam }) => {
  const classes = styles;
  const [showOptions, setShowOptions] = useState(null);
  const [allOption, setOption] = useState([
    {
      key: 1,
      hide: team.has_welcome_message,
      component: (
        <RecordWelcomeMessage team={team} updateOption={updateOption} />
      ),
      team_role: [2],
    },
    {
      key: 2,
      hide: false,
      component: <TeamEngagement team={team} />,
      team_role: [1, 2, 3, 4],
    },
    {
      key: 3,
      hide: false,
      component: <TeamDelete team={team} />,
      team_role: [2],
    },
    {
      key: 4,
      hide: false,
      component: <ShowNotifications team={team} setTeam={setTeam} />,
      team_role: [1, 2, 3, 4],
    },
    {
      key: 5,
      hide: false,
      component: <Webhook />,
      team_role: [2],
    },
    {
      key: 6,
      hide: false,
      component: <CourseSharing team={team} setTeam={setTeam} />,
      team_role: [2],
    },
    // {
    //   key: 6,
    //   hide: false,
    //   component: <ShowChatGpt team={team} setTeam={setTeam} />,
    //   team_role: [2],
    // },
  ]);

  const handleOptionsPopper = (event) => {
    if (!showOptions) {
      setShowOptions(event.currentTarget);
      return;
    }
    setShowOptions(null);
    return;
  };

  const hideOptionsPopper = () => {
    setShowOptions(null);
  };

  function updateOption() {
    hideOptionsPopper();
    var optionCopy = { ...allOption[0] };
    optionCopy.hide = true;

    const allOptionCopy = [...allOption];

    allOptionCopy[
      allOptionCopy.findIndex((tOption) => {
        return tOption.key === optionCopy.key;
      })
    ] = {
      ...optionCopy,
    };

    setOption(allOptionCopy);
  }

  return (
    <div className="teamOptionsRoot">
      <div style={classes.heading} onClick={handleOptionsPopper}>
        <div className="teamOptionsContent">
          <div style={{ display: "flex", gap: "10px" }}>
            <TeamInformation style={classes.icon} />
            Team Options
          </div>
          {!Boolean(showOptions) && (
            <FontAwesomeIcon
              icon={faChevronDown}
              style={{ pointerEvents: "none" }}
            />
          )}
          {Boolean(showOptions) && (
            <FontAwesomeIcon
              icon={faChevronUp}
              style={{ pointerEvents: "none" }}
            />
          )}
        </div>
      </div>
      <CSSTransition
        in={Boolean(showOptions)}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <ClickAwayListener onClickAway={hideOptionsPopper}>
          <div style={classes.rootDropDown}>
            <div style={classes.contentDropDown}>
              <ul style={{ listStyle: "none" }} className="allTeamOptions">
                {allOption.map(
                  (option) =>
                    option.team_role.includes(team?.role_id) &&
                    !option.hide && (
                      <li key={option?.key} style={classes.list}>
                        {option.component}
                      </li>
                    )
                )}
              </ul>
            </div>
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
};
